import { memo } from "react";
import { Grid, CheckboxProps, Checkbox } from "semantic-ui-react";

type DHCPStatusProps = {
  onChange: (
    event: React.FormEvent<HTMLInputElement>,
    data: CheckboxProps,
  ) => void;
  enableDhcp: boolean;
};

const DHCPStatus = ({ onChange, enableDhcp }: DHCPStatusProps) => {
  return (
    <Grid.Row>
      <Grid.Column textAlign="left" width={8} className="flex vbottom">
        <h5>DHCP</h5>
      </Grid.Column>
      <Grid.Column textAlign="left" width={8}>
        <Checkbox
          className="display-inlineblock"
          toggle
          checked={enableDhcp}
          label={enableDhcp ? "Enabled" : "Disabled"}
          name="enableDhcp"
          onChange={onChange}
        />
      </Grid.Column>
    </Grid.Row>
  );
};

export default memo(DHCPStatus);
